module.exports = __webpack_public_path__ + "img/arrow-right-circle.75545312.svg";